import type { LucideIcon } from "lucide-react";

import { cn } from "@/lib/cn";
import { emptyPlaceholder } from "@/utils";

/** 单行字段：图标 + 标签 + 值 */
export const DetailInfoRow = ({
  icon: Icon,
  label,
  value,
  mono,
  full,
}: {
  icon: LucideIcon;
  label: string;
  value?: string | number | null | React.ReactNode;
  mono?: boolean;
  full?: boolean;
}) => (
  <div className={cn("flex items-center gap-1.5 text-sm min-w-0", full && "col-span-2")}>
    <Icon className="w-3.5 h-3.5 text-slate-400 shrink-0" />
    <span className="text-slate-500 w-24 shrink-0">{label}</span>
    <span className={cn("truncate text-slate-800", mono && "font-mono text-xs")}>
      {emptyPlaceholder(value)}
    </span>
  </div>
);

/** 子标题（如绑定记录） */
export const SubSectionTitle = ({ title }: { title: string }) => (
  <h5 className="text-xs font-medium text-slate-500 mb-2 m-0">{title}</h5>
);
